import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client'
import { cachedNotesContext } from './context'
import { createIDBPersister } from './utils'
import { cachedNotesQueryClient, cacheTime } from './client'

const idbPersister = createIDBPersister()

export function CachedNotesProvider({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <PersistQueryClientProvider
      context={cachedNotesContext}
      client={cachedNotesQueryClient}
      persistOptions={{ persister: idbPersister, maxAge: cacheTime }}
    >
      {children}
    </PersistQueryClientProvider>
  )
}
